<template>
  <div id="header" class="w-full mb-2">
    <nav id="navbar" class="py-2">
      <div class="flex items-center justify-between h-12 gap-2">
        <div class="flex justify-start flex-1 items-end">
          <router-link id="navbar-logo" class="up" to="/">
            <img class="min-w-full w-24 md:w-auto md:h-8 lg:h-10 xl:h-12" src="@/assets/logo.png" alt="EASY" />
          </router-link>
          <div class="flex items-center gap-2 ml-2">
            <div>by</div>
            <div id="wrapper">
              <a href="https://www.homconcept.com/" target="_blank" rel="noopener noreferrer">
                <img class="object-cover h-8 py-2 md:h-8 lg:h-10 xl:h-12 hidden sm:block" src="@/assets/logo_home_concept.png" alt="HOME CONCEPT" />
                <img class="object-cover h-8 py-2 md:h-8 lg:h-10 xl:h-12 block sm:hidden" src="@/assets/logo_HC.png" alt="HOME CONCEPT" />
              </a>
              <div id="after"></div>
            </div>
          </div>
        </div>
        <GenericButton
          v-if="this.urlCopied === false"
          :text="''"
          :icon="'share'"
          :isDisabled="this.$store.state.currentConfiguration.length == 0"
          @click="share"
        />
        <GenericButton v-else :text="''" :icon="'clipboard-check'" :isDisabled="true" :class="'success'" />
        <a :href="this.emailLink" target="_blank">
          <GenericButton :text="''" :icon="'mail'" />
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import GenericButton from '@/components/ui/GenericButton.vue';
import { encodeURL } from '@/utils/utils.js';

export default {
  name: 'HeaderBar',
  components: {
    GenericButton,
  },
  computed: {
    encodedURL() {
      return encodeURL(window.location.origin, this.$store.state.currentConfiguration);
    },
    emailLink() {
      if (this.$store.state.currentConfiguration.length == 0) {
        return (
          'mailto:home-concept@sfr.fr?subject=Demande%20de%20devis%20EASY%20dressing' +
          '&body=Bonjour,%0D%0DJ%27aimerais%20convenir%20d%27un%20rendez-vous%20avec%20vous%20pour%20un%20projet%20de%20dressing.%0D%0DCordialement,'
        );
      }
      return 'mailto:home-concept@sfr.fr?subject=Demande%20de%20devis%20EASY%20dressing&body=%0D%0DLien%20vers%20ma%20configuration%20:%0D' + this.encodedURL;
    },
  },
  data() {
    return {
      urlCopied: false,
    };
  },
  methods: {
    share() {
      // If no configuration has been defined yet, do not do anything
      if (this.$store.state.currentConfiguration.length == 0) {
        return;
      }

      // Copy the configuration link to the clipboard
      navigator.clipboard.writeText(this.encodedURL);
      this.urlCopied = true;

      // Enable the user to copy the configuration link again after 3 seconds
      setTimeout(() => {
        this.urlCopied = false;
      }, 3000);
    },
    currentConfigurationChanged() {
      // Make the user being able to copy the configuration link once again directly
      this.urlCopied = false;
    },
  },
};
</script>

<style scoped>
#header {
  padding: 0 1rem;
}

#navbar {
  border-bottom: 3px black solid;
}

#wrapper > a {
  display: flex;
  align-items: center;
}

#after {
  background-color: #993973;
  width: 100%;
  height: 3px;
  transition: width 250ms ease-in-out;
  margin-top: -3px;
  pointer-events: none;
}

#wrapper:hover #after {
  width: 0%;
}

#external-icon {
  display: inherit;
}
</style>
